export default __webpack_public_path__ + "static/media/Increased.b6675640.png";